import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import Typography from '@material-ui/core/Typography';
import ReactGA from 'react-ga';


const styles = theme => ({
  button: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    alignItems: 'right',
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  detailHeader: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    //paddingLeft: '5px',
    //paddingTop: '5px',
  },
  contrastText: {
    color: theme.palette.primary.contrastText,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
  },
  buttonList: {
    textAlign: 'right',
  },
  whiteBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10%',
    //padding: '10px',
    width: '80%',
    height: '60%',
    //border: '1px',
  },
  container: {
    display: 'flex',
    width:'100%',
    height:'100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  componentContent: {
    minHeight: 'calc(100% - 35px)',
  },
});

class Contact extends Component {

  componentWillMount() {

    ReactGA.initialize('UA-107081605-2');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  handleBackClick = () => {
    //console.log('back clicked');
    this.props.history.goBack()
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.componentContent}>
            <Paper className={classes.detailHeader}>
              <IconButton className={classes.contrastText} aria-label="Menu" onClick={this.handleBackClick}>
                <NavigateBeforeIcon />
              </IconButton>

              <Typography className={classes.contrastText}  variant="subheading" color="inherit">
                CONTACT
              </Typography>
            </Paper>
            <Paper>
              <div className={classes.container}>
                <Paper className={classes.whiteBox}>
                  <Typography className={classes.listText}  variant="headline" color="inherit">
                    Have feedback or need to get in touch?
                  </Typography>
                  <Typography variant="headline" color="inherit">
                    Say <a href="mailto:hello@hipkar.com">hello@hipkar.com</a>
                  </Typography>
                </Paper>
              </div>

            </Paper>
      </div>
    );
  }

}

Contact.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact.jsx